import { useShouldShowInContextAnalysis } from '@modules/analysis/hooks';
import { useGetDashboardAnalysisLinkWithState } from '@modules/dashboard/hooks';
import { Link, Stack } from '@mui/material';
import { AnalysisViewFragment } from 'generated/graphql';
import { Link as RouterLink } from 'react-router-dom';

interface DashboardAnalysisTitleProps {
  analysis: AnalysisViewFragment;
}

export const DashboardAnalysisTitle = ({
  analysis,
}: DashboardAnalysisTitleProps) => {
  const { analysisLink, analysisLinkState } =
    useGetDashboardAnalysisLinkWithState(analysis);
  const shouldShowInContextAnalysis = useShouldShowInContextAnalysis();

  const props = shouldShowInContextAnalysis
    ? {}
    : {
        component: RouterLink,
        to: analysisLink,
        state: analysisLinkState,
      };

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      onClick={
        shouldShowInContextAnalysis ? undefined : (e) => e.stopPropagation()
      }
    >
      <Link
        variant="subtitle1"
        className="dashboard-analysis-title"
        {...props}
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          textDecoration: 'none',
          color: 'text.primary',
          '&:hover': {
            textDecoration: shouldShowInContextAnalysis ? 'none' : 'underline',
            color: 'primary.main',
          },
        }}
      >
        {analysis.title}
      </Link>
    </Stack>
  );
};
